import { breakpoints, defaultTheme } from 'gd-design-library';
import { colors } from './colors';

export const breadcrumbs = {
  ...defaultTheme.breadcrumbs,
  default: {
    ...defaultTheme.breadcrumbs.default,
    flexWrap: 'wrap',
    color: colors.neutral['grey.80'],
    fontSize: '0.875rem',
    gap: 8,
    [`@media (max-width: ${breakpoints.md})`]: {
      fontSize: '12px',
      lineHeight: '16px'
    }
  }
};
